module.exports = __webpack_public_path__ + "static/media/spectaclemozart.af14613d.jpg";